import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import propTypes from 'prop-types';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const BarChart = ({chartLabels, chartData, ...rest})=> {
  const options = {
    indexAxis: rest.chartLayoutVertical === true ? 'x': 'y',
    elements: {
      bar: {
        borderWidth: 2,
      },
    },
    responsive: true,
    maintainAspectRatio: rest.chartLayoutVertical ? true: false,
    plugins: {
      legend: {
        position: 'top',
      },
      title: {
        display: false,
        text: rest.title,
      },
      tooltip: {
        enabled: true,
        callbacks: {
          label: (item) => rest.isPercent ? `${item.formattedValue}%` : `${item.formattedValue}`,
          title: (item)=>item[0].label.replace(",", " ")
        }
      }
    },
    scales: {
      y: {
        title: {
          display: true,
            text: rest.yAxisLabel,
            font: value=>{
              var width = value.chart.width;
              var size = Math.round(width / (rest.chartLayoutVertical === true ? 50:65));
               return {
                 size: size
              };
            }
          },
          autoSkip: rest.chartLayoutVertical === true ? true: false,
        ticks: {
          font: value=>{
            var width = value.chart.width;
            var size = Math.round(width / (rest.chartLayoutVertical === true ? 50:85));
             return {
               size: size
            };
          },
        }
      },
      x: {
        title: {
          display: true,
          text:rest.xAxisLabel,
          font: value=>{
            var width = value.chart.width;
            var size = Math.round(width / (rest.chartLayoutVertical === true ? 50:65));
             return {
               size: size
            };
          }
        },
        ticks: {
          padding: 10,
          font: value=>{
            var width = value.chart.width;
            var size = Math.round(width / rest.xAxisFontSize);
             return {
               size: size
            };
          },
          autoSkip: false,
          maxRotation: rest.xAxisRotation,
          minRotation: rest.xAxisRotation
        }
      }
    }
  };
  const data = {
    labels:  chartLabels,
    datasets: [{
      axis: rest.chartLayoutVertical === true ? 'x': 'y',
      label: rest.yAxisLabel,
      data: chartData,
      backgroundColor: rest.backgroundColor
    }]
  };
  if(rest.chartLayoutVertical){
    options.scales.y.ticks.callback = value =>{
      return rest.isPercent ? value + "%" : Intl.NumberFormat('en-US').format(value)
    }
    options.scales.y.ticks.stepSize = rest.yAxisIncrement;
    options.scales.y.max = rest.yAxisMax;
  } else{
    options.scales.x.ticks.callback = value =>{
      return rest.isPercent ? value + "%" : Intl.NumberFormat('en-US').format(value)
    }
    options.scales.x.max = rest.yAxisMax;
    options.scales.x.ticks.stepSize = rest.yAxisIncrement;
  }
  return (
    <div className={`desktop:display-block mobile:display-none ${rest.chartLayoutVertical === false ? "chart-container" : ""}`}>
      <Bar options={options} data={data} aria-label={`${rest.title}.`}/>
    </div>
  );
}
export default BarChart;
BarChart.propTypes = { 
  title: propTypes.string,
  chartLabels: propTypes.array,
  chartData: propTypes.array,
  xAxisLabel: propTypes.string,
  yAxisLabel: propTypes.string,
  backgroundColor: propTypes.array,
  chartLayoutVertical: propTypes.oneOf([true, false]),
  yAxisMax: propTypes.number,
  yAxisIncrement: propTypes.number,
  isPercent: propTypes.bool,
  chartLabelsVertical: propTypes.bool,
  xAxisFontSize: propTypes.number,
  xAxisRotation: propTypes.number,
}
BarChart.defaultProps = {
  title: "",
  chartLabels: [],
  chartData: [],
  xAxisLabel: "",
  yAxisLabel: "",
  backgroundColor: ['#383E56'],
  chartLayoutVertical: true,
  yAxisMax: 50000,
  yAxisIncrement: 5,
  isPercent: false,
  chartLabelsVertical: false,
  xAxisFontSize: 50,
  xAxisRotation: 0,
}